<template>
    <topHeader />
    <div class="service-page">
        <div class="container">
            <div class="service-content">
                <h1>机构服务信息</h1>
                <p class="region-hours"><i class="iconfont icon-time"></i> 冬季办公时间8:30-12:00&nbsp;&nbsp;&nbsp;&nbsp;13:30-17:30</p>
                <p class="region-hours"><i class="iconfont icon-time"></i> 夏季办公时间(6月-8月):8:30-12:00&nbsp;&nbsp;&nbsp;&nbsp;14:30-17:30</p>
                <div class="departments">
                    <div v-for="(region, index) in departments" :key="index" class="region-container">
                        <div class="region-header">
                            <h2>{{ region.name }}</h2>
                            <!-- <p class="region-hours"><i class="iconfont icon-time"></i> 工作时间：{{ region.workHours }}</p> -->
                        </div>
                        <div class="departments-list">
                            <div v-for="(dept, deptIndex) in region.child" :key="deptIndex" class="department-item">
                                <div class="department-header">
                                    <h3>{{ dept.name }}</h3>
                                </div>
                                <div class="department-info">
                                    <p><i class="iconfont icon-phone"></i> 联系电话：{{ dept.phone }}</p>
                                    <p><i class="iconfont icon-location"></i> 地址：{{ dept.address }}</p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
    </div>
  </div>
  <Footer />
</template>
<script>
import TopHeader from './top-Header.vue'
import Footer from './Footer.vue'
export default {
    name: 'serveList',
    components: {
        TopHeader,
        Footer
    },
    data() {
        return {
            departments: [
                {
                    name: '秦皇岛市',
                    workHours: '周一至周五 9:00-17:00',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335-3923331',
                            address: '海港区民族路6号'
                        },
                        {
                            name: '水务局',
                            phone: '0335-3610347',
                            address: '海港区秦皇东大街143号'
                        }
                    ]
                },
                {
                    name: '海港区',
                    workHours: '周一至周五 9:00-17:30',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335-3558001',
                            address: '海港区迎宾路泛亚大厦'
                        },
                        {
                            name: '水务局',
                            phone: '0335-3554589',
                            address: '秦皇岛市海港区文化路街道河北大街中段296号蓝天大厦'
                        }
                    ]
                },
                {
                    name: '北戴河区',
                    workHours: '周一至周五 9:00-17:00',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335-44683715',
                            address: '北戴河区新河路21号'
                        },
                        {
                            name: '水务局',
                            phone: '0335-4186694',
                            address: '秦皇岛市北戴河区戴河镇金一路16号'
                        }
                    ]
                },
               
                
                {
                    name: '山海关区',
                    workHours: '周一至周五 9:00-17:00',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335-5136068',
                            address: '山海关区龙海大道与228交叉口东北260米'
                        },
                        {
                            name: '水务局',
                            phone: '0335-5135333',
                            address: '山海关区龙海大道201号'
                        }
                    ]
                },
                {
                    name: '开发区',
                    workHours: '周一至周五 9:00-17:00',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335-8019004',
                            address: '秦皇岛经济技术开发区秦皇西大街369号泰盛商务大厦'
                        },
                        {
                            name: '社发局',
                            phone: '0335-80171919',
                            address: '秦皇岛经济技术开发区腾飞路8号'
                        }
                    ]
                },
                
                {
                    name: '北戴河新区',
                    workHours: '周一至周五 9:00-17:00',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335-3592711',
                            address: '北戴河新区前程大街与锦绣一路交叉口'
                        },
                        {
                            name: '社发局',
                            phone: '0335-3592848',
                            address: '河北省秦皇岛北戴河新区十号街1号创业基地'
                        }
                    ]
                },
              
                {
                    name: '卢龙县',
                    workHours: '周一至周五 9:00-17:00',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335-7208533',
                            address: '秦皇岛市卢龙县厚德路东侧'
                        },
                        {
                            name: '水务局',
                            phone: '0335-7619788',
                            address: '秦皇岛市卢龙县环城东路5号'
                        }
                    ]
                },
                  {
                    name: '青龙县',
                    workHours: '周一至周五 9:00-17:00',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335-7995899',
                            address: '青龙满族自治县青龙镇八旗街北段县政府东配楼'
                        },
                        {
                            name: '水务局',
                            phone: '0335-7882009',
                            address: '青龙满族自治县祖山路156号'
                        }
                    ]
                },
                {
                    name: '昌黎县',
                    workHours: '周一至周五 9:00-17:00',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335–2883766',
                            address: '昌黎县五峰山路南段东侧'
                        },
                        {
                            name: '水务局',
                            phone: '0335-2022757',
                            address: '河北省秦皇岛市昌黎县昌黎镇二街西北楼14号'
                        }
                    ]
                },
                {
                    name: '抚宁区',
                    workHours: '周一至周五 9:00-17:00',
                    child:[
                        {
                            name: '审批局',
                            phone: '0335-7692187',
                            address: '秦皇岛市抚宁区金山大街2号'
                        },
                        {
                            name: '水务局',
                            phone: '0335-6682538',
                            address: '秦皇岛市抚宁区迎宾路178号'
                        }
                    ]
                },
            ]
        }
    }
}
</script>
<style scoped>
.service-page {
    background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
    padding: 40px 0;
    min-height: calc(100vh - 60px);
}

.container {
    width: 1200px;
    max-width: 1200px;
    margin: 0 auto;
}

.service-content {
    text-align: center;
}

.service-content h1 {
    font-size: 2.5rem;
    color: #333;
    margin-bottom: 40px;
    font-weight: 600;
    position: relative;
    display: inline-block;
}

.service-content h1::after {
    content: '';
    position: absolute;
    bottom: -10px;
    left: 50%;
    transform: translateX(-50%);
    width: 100px;
    height: 4px;
    background: linear-gradient(90deg, #4a6fa5, #6e8cb6);
    border-radius: 2px;
}

.departments {
    display: grid;
    grid-template-columns: repeat(auto-fit, minmax(350px, 1fr));
    gap: 30px;
    margin-top: 40px;
}

.region-container {
    background: rgba(255, 255, 255, 0.95);
    border-radius: 12px;
    padding: 20px;
    box-shadow: 0 8px 32px rgba(31, 38, 135, 0.1);
    backdrop-filter: blur(4px);
    border: 1px solid rgba(255, 255, 255, 0.18);
    transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.region-container:hover {

    box-shadow: 0 12px 40px rgba(31, 38, 135, 0.15);
}

.region-header {
    border-bottom: 2px solid #e8f4f8;
    padding-bottom: 15px;
    margin-bottom: 20px;
}

.region-header h2 {
    font-size: 1.8rem;
    color: #2c3e50;
    margin: 0 0 10px 0;
    font-weight: 600;
}

.region-hours {
    font-size: 0.95rem;
    color: #7f8c8d;
    margin: 10px 0;
}

.departments-list {
    display: flex;
    flex-direction: column;
    gap: 15px;
}

.department-item:not(:first-child) {
    border-top: 1px solid #e8f4f8;
    padding-top: 15px;
}
.department-item {
    padding: 0;
    background: none;
    box-shadow: none;
    border-radius: 0;
    transition: none;
}

.department-item:hover {
    transform: none;
    box-shadow: none;
    background: none;
}

.department-header {
    display: block;
    margin-bottom: 10px;
    text-align: left;
}

.department-header h3 {
    padding-left:10px;
    font-size: 1.2rem;
    color: #2c3e50;
    margin: 0 0 10px 0;
    font-weight: 600;
    text-align: left;
}

.department-header h2 {
    font-size: 1.6rem;
    color: #333;
    margin: 0;
}

.department-info {
    text-align: left;
}

.department-info p {
    margin: 12px 0;
    font-size: 1rem;
    color: #555;
    display: flex;
    align-items: center;
}

.department-info i {
    color: #4a6fa5;
    margin-right: 10px;
    font-size: 1.1rem;
}

/* 响应式设计 */
@media (max-width: 768px) {
    .service-content h1 {
        font-size: 2rem;
    }
    
    .departments {
        grid-template-columns: 1fr;
    }
    
    .department-item {
        padding: 20px;
    }
    
    .department-icon {
        width: 50px;
        height: 50px;
        font-size: 20px;
    }
    
    .department-header h2 {
        font-size: 1.4rem;
    }
}
</style>